// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3uJvj","inputDescription":"styles_inputDescription__BvY7s"};